export default (length: number, stringToTruncate: string): string => {
  if (stringToTruncate.length <= length) { return stringToTruncate; }
  const s: string = stringToTruncate.substr(0, length);
  return `${s.substr(0, s.lastIndexOf(' '))}...`;
};
